import { APPROVE_SERVICE } from "./../../routes";
import customAxios from "../../customAxios";
import { Approve_Service_AdminiStrator } from "../../../types/common.type";

type Props = {
  _id: string;
  isApprove: boolean;
  approveType: Approve_Service_AdminiStrator;
};

const approveSchool = async (props: Props) => {
  try {
    return (
      await customAxios.put(APPROVE_SERVICE, {
        approveType: props.approveType,
        isApprove: props.isApprove,
        serviceId: props._id,
      })
    ).data;
  } catch (error: unknown) {
    console.error({ APPROVE_SERVICE: error });
    return false;
  }
};

export default approveSchool;
